import { useState } from "react";
import { useDispatch } from "react-redux";
import api from "../../storage/api";
import { modalActions } from "../../storage/modals";
import Supplements from "./Supplements";

const Catalog = (props) => {
  const allProducts = props.products;
  const [filteredProducts, setFilteredProducts] = useState(allProducts);
  const [currentCategory, setCurrentCategory] = useState("all");
  const dispatch = useDispatch();

  const changeCategoryHandler = (cat) => {
    setCurrentCategory(cat);

    if (cat === "all") {
      setFilteredProducts(allProducts);
    } else {
      const newFilter = allProducts.filter((item) => {
        return item.category === cat;
      });
      setFilteredProducts(newFilter);
    }
  };

  const searchHandler = (event) => {
    const search = event.target.value;

    const newFilter = allProducts.filter((item) => {
      if (currentCategory === "all") {
        return item.name.toLowerCase().includes(search.toLowerCase());
      } else {
        return item.name.toLowerCase().includes(search.toLowerCase()) && item.category === currentCategory;
      }
    });

    setFilteredProducts(newFilter);
  };

  const addToCart = (id) => {
    dispatch(modalActions.showAddToCartModal(id));
  };

  return (
    <>
      <section className="catalog">
        <div className="container">
          <div className="common-title">
            <h2 className="common-title__h2">
              Все <span>товары</span>
            </h2>
            <p className="common-title__subtitle">расширяй возможности: аксессуары и привилегии для тебя!</p>
          </div>
        </div>
      </section>
      {(props.rpmpass || props.currency) && <Supplements rpmpass={props.rpmpass} currency={props.currency} />}
      <section className="catalog">
        <div className="container">
          <div className="catalog-filters-wrapper">
            <div className="catalog-filters">
              <span className="catalog-filters-title">Категории товаров</span>
              <div className="catalog-filters-items">
                <button
                  type="button"
                  className={currentCategory === "all" ? "catalog-filter catalog-filter_active" : "catalog-filter"}
                  onClick={() => {
                    changeCategoryHandler("all");
                  }}
                >
                  Все товары
                </button>
                {props.categories.map((item, key) => (
                  <button
                    type="button"
                    className={currentCategory === item ? "catalog-filter catalog-filter_active" : "catalog-filter"}
                    key={key}
                    onClick={() => {
                      changeCategoryHandler(item);
                    }}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>
            <div className="catalog-search">
              <span className="catalog-filters-title">Поиск</span>
              <input type="text" className="catalog-search__input" placeholder="Введите название" onInput={searchHandler} />
            </div>
          </div>
          <div className="products">
            {filteredProducts.length === 0 && <p>Ничего не найдено</p>}
            {filteredProducts.map((item) => {
              let discount = 0;

              if (item.old_price > item.price) {
                discount = (((item.old_price - item.price) * 100) / item.old_price).toFixed(0);
              }

              return (
                <div className={item.popular === "1" ? "product product_popular" : "product"} key={item.id}>
                  {discount > 0 && <span className="product-discount">-{discount}%</span>}
                  <div className="product__half product__half_top">
                    <div className="product-top">
                      <img src={item.icon ? api.apiUrl + item.icon : "/assets/images/dummy_product.png"} className="product-icon" alt={item.name} />
                      {item.popular === "1" && <span className="product-popular-label">Популярный</span>}
                    </div>
                    <div className="product-bottom">
                      <h5 className="product-title">{item.name}</h5>
                      <div className="product-price">
                        <span className="product-price__value">{item.price} &#8381;</span>
                        <div className="product-price__attrs">
                          {item.old_price > item.price && <span className="product-price-old">{item.old_price} &#8381;</span>}
                          <span className="product-duration" style={item.price > item.old_price ? { marginTop: "10px" } : undefined}>
                            {item.period}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="product__half product__half_bottom">
                    <button
                      type="button"
                      className="product-buy"
                      onClick={() => {
                        addToCart(item.id);
                      }}
                    >
                      Купить
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Catalog;
